skrilla.directive('queryBettingMarkets', function (uiUrlsService) {
  return {
    templateUrl: 'directives/queryBettingMarkets/queryBettingMarkets.html',
    scope: {
      bettingMarkets: "=",
      key: "="
    },
    controller: async function ($scope, searchService, queryService, paginationService, cacheService, sportService, currencyService, bettingReferenceService, $location, _) {
      const eventId = $location.search().eventId || null;

      $scope.sports = await sportService.getSports()

      $scope.currencies = currencyService.getCurrencies();
      $scope.eventTypes =  bettingReferenceService.eventTypes().reduce((a, v) => ({ ...a, [v]: false}), {});
      $scope.matchSourceTypes =  bettingReferenceService.matchSourceTypes().reduce((a, v) => ({ ...a, [v]: false}), {});

      const sports = [];

      const baseQuery = {
        sports,
        eventTypes: $scope.eventTypes,
        sourceTypes: $scope.matchSourceTypes,
        limit: 50,
        sortBy: "scheduled_start_time",
        sortOrder: "ASC",
        showMore: true,

      }

      const defaultQuery = {
        ...baseQuery,
        showMore: false,
        betOn: true,
        excludeRejectedBets: true,
        statuses: {
          SUSPENDED: true,
          DEACTIVATED: true,
          UNAVAILABLE: true,
          ACTIVE: false,
          HANDED_OVER: false,
          SETTLED: false,
          CANCELLED: false,
        },
      };
      const activeQuery = {
        ...baseQuery,
        betOn: false,
        excludeRejectedBets: false,
        eventId: null,
        statuses: {
          SUSPENDED: false,
          DEACTIVATED: false,
          UNAVAILABLE: false,
          ACTIVE: true,
          HANDED_OVER: false,
          SETTLED: false,
          CANCELLED: false,
        },
      };
      const unsettledQuery = {
        ...baseQuery,
        betOn: true,
        excludeRejectedBets: true,
        eventId: null,
        statuses: {
          SUSPENDED: true,
          DEACTIVATED: true,
          UNAVAILABLE: false,
          ACTIVE: false,
          HANDED_OVER: false,
          SETTLED: false,
          CANCELLED: false,
        },
        maxMinutesAfterStartTime: -60,
        maxMinutesBeforeStartTime: null,
      };

      const defaultEntryIdQuery = {
        eventTypes: $scope.eventTypes,
        sourceTypes: $scope.matchSourceTypes,
        betOn: false,
        excludeRejectedBets: false,
        eventId: eventId,
        statuses: {
          SUSPENDED: false,
          DEACTIVATED: false,
          UNAVAILABLE: false,
          ACTIVE: false,
          HANDED_OVER: false,
          SETTLED: false,
          CANCELLED: false,
        },
      };

      $scope.reset = function () {
        $scope.query = {
          ...defaultQuery, eventId: null
        };
      };
      $scope.showActive = function () {
        $scope.query = activeQuery;
      };
      $scope.showUnsettled = function () {
        $scope.query = unsettledQuery;
        $scope.startTimeFilter = "minutes";
      };

      $scope.search = function () {
        paginationService.resetPage($scope.key);
        paginationService.pageQuery(getMarkets, $scope.key);
      }

      var getMarkets = function () {

        if ($scope.startTimeFilter === 'none') {
          $scope.query.afterDate = null;
          $scope.query.beforeDate = null;
        }
        if ($scope.startTimeFilter === 'minutes') {
          if ($scope.query.maxMinutesBeforeStartTime || $scope.query.maxMinutesBeforeStartTime === 0) {
            $scope.query.afterDate = moment.utc().subtract($scope.query.maxMinutesBeforeStartTime, 'minutes').toISOString();
          } else {
            $scope.query.afterDate = null
          }
          if ($scope.query.maxMinutesAfterStartTime || $scope.query.maxMinutesAfterStartTime === 0) {
            $scope.query.beforeDate = moment.utc().add($scope.query.maxMinutesAfterStartTime, 'minutes').toISOString();
          } else {
            $scope.query.beforeDate = null
          }
        }
        if ($scope.query.betOn === false) $scope.query.excludeRejectedBets = false
        cacheService.registerObject("queryBettingMarkets", $scope.query)
        return searchService.get("betting/markets" + queryService.getQueryString($scope.query, $scope.key), true, true).then(function (response) {
          $scope.bettingMarkets = response.data.result;
          $scope.bettingMarkets.forEach(function (market) {
            market.seasonName = _.get(market, "event.attributes.seasonName") || _.get(market, "event.attributes.tournamentName")
            // market.eventSport = market.event.sport;
            // market.eventName = market.event.eventName;
            // market.eventScheduledStartTime = market.event.scheduledStartTime;
          });

          const eventIds = _.groupBy($scope.bettingMarkets, it => it.event.id);
          const events = _($scope.bettingMarkets)
            .map(it => it.event)
            .uniqBy(it => it.id)
            .sort(it => it.scheduledStartTime)
            .map(it => {
                it.markets = eventIds[it.id];
                it.uiUrl = uiUrlsService.getEventBettingUrl(it)

                const startTime = moment.utc(it.scheduledStartTime)
                const minutesTilStart = startTime.diff(moment(), 'minutes');
                it.minutesTilStart = minutesTilStart;
                it.watching = (minutesTilStart <= 60 && _.some(it.markets, it2 => it2.status == 'ACTIVE')) ||
                  (minutesTilStart <= -120 && _.some(it.markets, it2 => it2.status == 'DEACTIVATED'));
                return it;
              }
            ).value();

          cacheService.registerObject("bettingMarketsTable", events);
          $scope.bettingMarkets = events
          paginationService.setPage($scope.key, paginationService.buildPage(response));
        });
      }

      $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
          $scope.search();
      }

      if (eventId) {
        $scope.query = defaultEntryIdQuery;
        $scope.search();
      } else {
        $scope.query = cacheService.getObject("queryBettingMarkets")
        if (!$scope.query) {
          $scope.query = defaultQuery
        }
      }


      const checkedCount = function () {
        if (!$scope.query || !$scope.query.sports) return 0;
        return $scope.query.sports.length;
      };

      $scope.isIndeterminate = function () {
        return (checkedCount() !== 0 && checkedCount() !== $scope.sports.length);
      };

      $scope.isChecked = function () {
        return (checkedCount() === $scope.sports.length);
      };

      $scope.toggleAll = function () {
        if (!$scope.query) return;
        if ($scope.isChecked()) {
          $scope.query.sports = [];
        } else {
          $scope.query.sports = $scope.sports;
        }
      };
    }
  };
});
